export function chainName() {
  const customENV = process.env.REACT_APP_CUSTOM_ENV || 'prod'
  return customENV === 'dev' ? 'mumbai' : 'polygon'
}

//CONFIG DEFAULT VALUE
export const FIRST_DATE = new Date(2022, 10, 15, 7)
export const FIRST_DATE_TS = parseInt(FIRST_DATE / 1000)
export const FIRST_DATE_BORROWING_TS = parseInt(new Date(2022, 10, 20) / 1000)
export const DEFAULT_PLP_PRICE = 1
export const NOW_TS = parseInt(Date.now() / 1000)
